import * as $ from 'jquery';

const formsSelector 		 = 'form';
const waitingClassSuffix     = '--isWaiting';
const formWaitingClass 		 = 'form' + waitingClassSuffix;
const buttonClass            = 'btn';
const formButtons 			 = 'span.' + buttonClass;
const buttonWaitingClass 	 = buttonClass + waitingClassSuffix;
const waitingIndicatorClass  = buttonClass + '__waitingIndicator';
const fieldAreaClass         = 'fieldArea';
const focusClass 			 = fieldAreaClass + '--isFocus';
const hoverClass 			 = fieldAreaClass + '--isHover';
const filledClass 			 = fieldAreaClass + '--isFilled';
const formFieldSelector 	 = 'input, select, textarea';
const submissionTriggerClass = 'submissionTrigger';

/**
 * This class does following:
 * - While submitting toggles on *--isWaiting class on form and buttons
 * - Scrolls to messages area when AJAX submission complete
 * - Adds filledClass to form inputs that have values
 */
class Forms {
	private static instance: Forms;

	public constructor() {
		if (Forms.instance) {
			return Forms.instance;
		}
		Forms.instance = this;
	}

	public pauseForms($forms?: JQuery<Element|HTMLDocument>) {
		toggleForms($forms || $(formsSelector), true);
	}

	public releaseForms($forms?: JQuery<Element|HTMLDocument>) {
		toggleForms($forms || $(formsSelector), false);
	}

	/**
	 * Initialize forms. Can be called multiple times to reset forms.
	 */
	init() {
		// Immediately setup any buttons that are already waiting
		//setupTheseButtons($('.' + buttonWaitingClass));
		setupButtons(); // Ensure all buttons are setup.
		const $document = $(document);

		$document.on('submit', (event) => {
			if ($(formsSelector).hasClass(formWaitingClass)) {
				// We are waiting on a form. Do not do anything.
				event.preventDefault();
				return false;
			} else if (event.type === 'submit') {
				// Normal form submission
				this.pauseForms($(event.target));
			} else {
				// Catchall. Since we may not know the specific form we pause all of them
				this.pauseForms();
			}
		});

		document.addEventListener('jsfAjaxEvent', (event) => {
			const detail: any = (event as any).detail;
			if (detail !== undefined) {
				if (detail.fireType === 'always') {
					// Release form
					if (detail.source !== undefined && detail.source.form !== undefined) {
						this.releaseForms($(detail.source.form));
					} else {
						this.releaseForms(undefined);
					}

					Forms.scrollToMessages();
					markAllFilledInFields();
				} else if ($(formsSelector).hasClass(formWaitingClass)) {
					// We are waiting on a form. Do not do anything.
					event.preventDefault();
					return false;
				} else if (detail.fireType === 'begin') {
					// JSF Ajax
					if (detail.source !== undefined && detail.source.form !== undefined) {
						this.pauseForms($(detail.source.form));
					}
				} else {
					// Catchall. Since we may not know the specific form we pause all of them
					this.pauseForms();
				}
			}
		});

		// Add a class to fieldArea when user is hovering over or has focus on a form field. We use this to show any field specific messages.
		$document.on('mouseenter mouseleave focus blur', formFieldSelector, formFieldEventListener);

		// Add a class to fieldArea when not empty
		$document.on('change', formFieldSelector, function() {
			markSingleFilledInField($(this));
		});
		markAllFilledInFields();
	}

	/**
	 * Scroll page to messages if there are any and the user is not already scrolled down
	 */
	static scrollToMessages() {
		const $msgs = $('.messages');
		if ($msgs.length !== 0) {
			if (!elementInViewport($msgs.get(0), false)) {
				const offset = $msgs.first().offset();

				const $body = $(document.body);
				const sectionScroller = $body.data('sectionScroller');
				if (sectionScroller !== undefined) {
					sectionScroller.animateTo(offset.left, offset.top);
				} else {
					$body.stop().animate({'scrollTop' : offset.top}, 1000, 'easeOutQuart');
				}
			}
		}
	}
}

let submissionTriggerWrapper: Element = null;

function setupButtons() {
	// Setup all buttons that aren't already setup.
	setupTheseButtons($(formButtons));
}
function setupTheseButtons($buttons: JQuery<Element|HTMLDocument>) {
	$buttons.each(function() {
		const $this = $(this);
		if ($this.find('.' + waitingIndicatorClass).length === 0) {
			$this.on('click keyup submit', (event) => {
				if (!event.key || event.key === 'Enter') {
					if (!!submissionTriggerWrapper && $(formsSelector).hasClass(formWaitingClass)) {
						return;
					}
					(submissionTriggerWrapper = this as Element).classList.add(submissionTriggerClass);
				}
			});
			$this.append('<span class='+waitingIndicatorClass+'/>');
		}
	});
}

function toggleForms($forms: JQuery<Element|HTMLDocument>, state: boolean) {
	$forms.toggleClass(formWaitingClass, state);
	const $formsFormButtons = $(formButtons, $forms);
	$formsFormButtons.toggleClass(buttonWaitingClass, state);
	if (!state) {
		$formsFormButtons.toggleClass(submissionTriggerClass, false);
		submissionTriggerWrapper = null;
	} else if ($formsFormButtons.length === 1) { // If we reach this else-if check, state must be true, so we don't need to check it
		// If there is only a single button for that form, then we always show the spinner on it
		$formsFormButtons.toggleClass(submissionTriggerClass, true);
		submissionTriggerWrapper = $formsFormButtons.get(0);
	}
}

function formFieldEventListener(event: any) {
	let $input = $(this);
	let $area = $input.closest('.' + fieldAreaClass);

	if ($area.length === 0)
		return;

	let eventType = event.type;

	if (eventType === 'mouseenter') {
		$area.addClass(hoverClass);
	} else if (
		(eventType === 'mouseleave' && !$area.hasClass(focusClass)) ||
		(eventType === 'blur') ||
		(eventType === 'focusout')
	) {
		$area.removeClass(hoverClass);
		$area.removeClass(focusClass);
	} else if (eventType.indexOf('focus') > -1) {
		if ((($input.get(0) as HTMLInputElement).type === 'select-one') && $area.hasClass(hoverClass)) {
			// Remove if user clicked to open a select one field. Otherwise the arrow is partially visible.
			$area.removeClass(focusClass);
		} else {
			$area.addClass(focusClass);
		}
	}
}

function markAllFilledInFields($forms: JQuery<Element|HTMLDocument> = $(formsSelector)): void {
	for (let i: number = 0; i < $forms.length; i++) {
		const form: HTMLFormElement = $forms.get(i) as HTMLFormElement;
		const fields: HTMLFormControlsCollection = form.elements;
		for (let j: number = 0; j < fields.length; j++) {
			const field: JQuery<Element> = $(fields[j]);
			markSingleFilledInField(field);
		}
	}
}

function markSingleFilledInField($input:JQuery<Element|HTMLDocument>): void {
	let $area = $input.closest('.' + fieldAreaClass);

	if ($area.length === 0) {
		return;
	}

	let addClass = false;
	const inputType = $input.attr('type');
	if (inputType === 'checkbox' || inputType === 'radio') {
		addClass = ($input.get(0) as HTMLInputElement).checked;
	} else {
		addClass = $input.val() !== '';
		if (inputType === 'file') {
			if (addClass) {
				let filename = $input.val().toString();
				let lastSlash = filename.lastIndexOf('/');
				filename = filename.substr((lastSlash === -1 ? filename.lastIndexOf('\\') : lastSlash) + 1);
				$area.find('label').attr('data-filename', filename);
			} else {
				$area.find('label').removeAttr('data-filename');
			}
		}
	}

	$area.toggleClass(filledClass, addClass);
}

function elementInViewport(el: HTMLElement, acceptPartiallyVisible: boolean = false): boolean {
	let width = el.offsetWidth;
	let height = el.offsetHeight;

	let top = 0;
	let left = 0;
	while(el) {
		top += el.offsetTop;
		left += el.offsetLeft;

		if (el.offsetParent instanceof HTMLDivElement) {
			el = el.offsetParent;
		} else {
			break;
		}
	}

	if (acceptPartiallyVisible) {
		return (
			top < (window.pageYOffset + window.innerHeight) &&
			left < (window.pageXOffset + window.innerWidth) &&
			(top + height) > window.pageYOffset &&
			(left + width) > window.pageXOffset
		);
	} else {
		return (
			top >= window.pageYOffset &&
			left >= window.pageXOffset &&
			(top + height) <= (window.pageYOffset + window.innerHeight) &&
			(left + width) <= (window.pageXOffset + window.innerWidth)
		);
	}
}

export default new Forms();
